(() => {
  'use strict';

  const buttonSelector = '[data-peggrid-shop-now]';
  const preorderFields = [
    'properties[_purchase_type]',
    'selling_plan',
    'properties[_selling_plan_id]',
    'properties[Availability date]',
    'properties[Payment]',
  ];

  const nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (resource, options) {
      const url = typeof resource === 'string' ? resource : resource?.url || '';

      if (/\/cart\/add(?:\.js(?:on)?)?(?:\?|$)/.test(url) && options?.body instanceof FormData) {
        preorderFields.forEach((name) => options.body.delete(name));
      }

      return nativeFetch.apply(this, arguments);
    };
  }

  const deactivatePreorderGuard = () => {
    if (window.__nmPreorderEarlyGuard) {
      window.__nmPreorderEarlyGuard.active = false;
    }
  };

  const neutralisePreorderFields = (form) => {
    if (!form) return;

    for (const name of preorderFields) {
      form.querySelectorAll(`input[name="${CSS.escape(name)}"]`).forEach((input) => {
        if (input.value !== '') input.value = '';
        if (!input.disabled) input.disabled = true;
      });
    }
  };

  const removePreorderPresentation = (scope) => {
    scope?.querySelectorAll('.hengam-preorder-description').forEach((element) => element.remove());
  };

  const applyInStockState = (button) => {
    if (!button) return;

    deactivatePreorderGuard();

    const form = button.closest('form');
    const label = button.querySelector(':scope > span:not(.loading-spinner)');
    const text = button.dataset.peggridShopNowLabel || 'Shop now';

    if (button.classList.contains('hengam-preorder-button')) {
      button.classList.remove('hengam-preorder-button');
    }

    if (label && label.textContent.trim() !== text) {
      label.textContent = text;
    }

    for (const attribute of ['aria-label', 'title']) {
      const value = button.getAttribute(attribute);
      if (value && /pre[- ]?order/i.test(value)) {
        button.setAttribute(attribute, text);
      }
    }

    neutralisePreorderFields(form);
    removePreorderPresentation(button.closest('[id^="ProductInfo-"]') || form);
  };

  const initialiseButton = (button) => {
    if (!button || button.dataset.peggridShopNowInitialised === 'true') return;

    button.dataset.peggridShopNowInitialised = 'true';
    const form = button.closest('form');
    const scope = button.closest('[id^="ProductInfo-"]') || form || button.parentElement;

    applyInStockState(button);

    form?.addEventListener('formdata', (event) => {
      deactivatePreorderGuard();
      preorderFields.forEach((name) => event.formData.delete(name));
    });

    const observer = new MutationObserver(() => applyInStockState(button));
    observer.observe(scope, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['aria-label', 'title', 'disabled', 'value', 'class'],
    });
  };

  const initialise = (root = document) => {
    if (root.matches?.(buttonSelector)) initialiseButton(root);
    root.querySelectorAll?.(buttonSelector).forEach(initialiseButton);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest?.(buttonSelector);
    if (button) applyInStockState(button);
  }, true);

  document.addEventListener('submit', (event) => {
    const button = event.target.querySelector?.(buttonSelector);
    if (button) applyInStockState(button);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
